import CoverageAuditLogCardsView from './coverage_audit_logs/CoverageAuditLogCardsView'
import { CollapsibleDataContainer } from '../reusable/CollapsibleDataContainer'

interface EnrollmentAuditHistoryProps {
  enrollmentId: string
}

// Wrapper component to display coverage audit logs in a collapsible container
function EnrollmentAuditHistory ({ enrollmentId }: EnrollmentAuditHistoryProps) {
  const successContent = (
    <div className='px-4 pb-2'>
      <CoverageAuditLogCardsView enrollmentId={enrollmentId} pageSize={5} />
    </div>
  )

  return (
    <CollapsibleDataContainer
      heading='Coverage Audit Logs'
      localStorageKey='edit-enrollment-audit-history'
      successContent={successContent}
      isLoading={false}
    />
  )
}

export default EnrollmentAuditHistory
